<template>
  <div class="statistics">
    <el-row :gutter="12" type="flex">
      <el-col :span="6" class="leftMenu">
        <div class="LeftMenu">
          <div class="menuTitle" >
            <div class="titleText">
              发送统计
            </div>
            <!-- <hr class="hrl"> -->
          </div>
          <div class="menuList">
            <!-- <hr class="hrl"> -->
            <!-- 邮件送达 -->
            <div class="itemDiv" :class="activeItem=='emailService'?'activeItem':''" @click="changeMenu('emailService')">
              <i class="iconfont icon-icon-youjianfasong"></i>邮件送达
              <el-badge :value="sendSuccessNum" class="itemDivbadge" :type="activeItem=='emailService'?'primary':'info'">
              </el-badge>
            </div>
            <!-- 邮件退订 -->
            <div class="itemDiv" :class="activeItem=='emailCancel'?'activeItem':''" @click="changeMenu('emailCancel')">
              <i class="iconfont icon-icon-youjiantuiding"></i>邮件退订
              <el-badge :value="unsubscribeNum" class="itemDivbadge" :type="activeItem=='emailCancel'?'primary':'info'">
              </el-badge>
            </div>
            <!-- 软性弹回 -->
            <div class="itemDiv" :class="activeItem=='emailSoft'?'activeItem':''" @click="changeMenu('emailSoft')">
              <i class="iconfont icon-icon-ruanxingdanhui"></i>软性弹回
              <el-badge :value="softBounceNum" class="itemDivbadge" :type="activeItem=='emailSoft'?'primary':'info'">
              </el-badge>
            </div>
            <!-- 硬性弹回 -->
            <div class="itemDiv" :class="activeItem=='emailRebound'?'activeItem':''" @click="changeMenu('emailRebound')">
              <i class="iconfont icon-icon-yingxingdanhuibeifen"></i>硬性弹回
              <el-badge :value="hardBounceNum" class="itemDivbadge" :type="activeItem=='emailRebound'?'primary':'info'"> 
              </el-badge>
            </div>
            <!-- 手动排除 -->
            <div class="itemDiv" :class="activeItem=='emailExclude'?'activeItem':''" @click="changeMenu('emailExclude')">
              <i class="iconfont icon-icon-youjiantuiding"></i>手动排除
              <el-badge :value="excludeNum" class="itemDivbadge" :type="activeItem=='emailExclude'?'primary':'info'">
              </el-badge>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="18"  class="list" >
        <div class="rightList">
          <!-- 邮件送达 -->
          <div v-if="activeItem=='emailService'">
            <emailServiceList/>
          </div>
          <!-- 邮件退订 -->
          <div v-if="activeItem=='emailCancel'">
            <emailCancelList/>
          </div>
          <!-- 软性弹回 -->
          <div v-if="activeItem=='emailSoft'">
            <emailSoftbulletList/>
          </div>
          <!-- 硬性弹回 -->
          <div v-if="activeItem=='emailRebound'">
            <emailReboundList/>
          </div>
          <!-- 手动排除 -->
          <div v-if="activeItem=='emailExclude'">
            <emailExcludeList :sendEmail="sendEmail"/>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import emailServiceList from"@/components/intellect-marketing/statistics/emailService"
import emailCancelList from"@/components/intellect-marketing/statistics/emailCancel"
import emailSoftbulletList from"@/components/intellect-marketing/statistics/emailSoftbullet"
import emailReboundList from"@/components/intellect-marketing/statistics/emailRebound"
import emailExcludeList from"@/components/intellect-marketing/statistics/emailExclude"
import {initSendStatistic} from "@/utils/api/edmSubject"

export default {
  components:{
    emailServiceList,emailCancelList,emailSoftbulletList,emailReboundList,emailExcludeList,
  },
  data(){
    return{
      activeItem:'emailService',
      excludeNum:0,//手动排除数量
      hardBounceNum:0,//硬弹数量
      sendSuccessNum:0,//发送成功数量
      softBounceNum:0,//软弹数量
      unsubscribeNum:0,//退订数量
      sendEmail:'',//发送邮箱
    }
  },
  mounted(){
    this.getinitSendStatistic()
    // console.log(this.$route.query.email)
    if(this.$route.query.email){
      this.activeItem='emailExclude'
    }
    // 处理切换tab问题
    if(window.localStorage.getItem('activeItem')){
      this.activeItem=window.localStorage.getItem('activeItem')
      window.localStorage.removeItem('activeItem')
    }
  },
  methods:{
    changeMenu(type){
      this.activeItem=type
      if(this.$route.query.email){
        window.localStorage.setItem('activeItem',this.activeItem)
        window.location.href=window.location.href.split('?')[0]
      }
    },
    async getinitSendStatistic(){
      const res=await initSendStatistic()
      this.excludeNum=res.data.excludeNum
      this.hardBounceNum=res.data.hardBounceNum
      this.sendSuccessNum=res.data.sendSuccessNum
      this.softBounceNum=res.data.softBounceNum
      this.unsubscribeNum=res.data.unsubscribeNum
      this.sendEmail=res.data.sendEmail
    },
  },
}
</script>

<style lang="scss" scoped>
  .statistics{
    // height: 100%;
    /**修改全局的滚动条*/
    /**滚动条的宽度*/
    ::-webkit-scrollbar {
      width: 6px;
    }
    // 滚动条的滑块
    ::-webkit-scrollbar-thumb {
      background-color: rgba(144,147,153,.3);
      border-radius: 3px;
    }
    .leftMenu{
      min-height: calc(100vh - 105px);
    }
    .list{
      min-height: calc(100vh - 105px);
    }
  }

  .LeftMenu{
    background: #FFFFFF;
    // padding-bottom: 100px;
    height: 100%;
    .menuTitle{
      height: 63px;
      background-image: linear-gradient(180deg, #F3FAFF 0%, #FFFFFF 93%);
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #16181A;
      padding-left: 16px;
      line-height: 63px;
      padding-right: 16px;
      .titleText{
        border-bottom: 1px solid #E5E8ED;
      }
    }
    .menuList{
      text-align: center;
      padding: 0 16px;
      margin-top: 8px;
      .itemDiv{
        height: calc(44 / 1200 * 100%);
        border-radius: 4px;
        line-height: 44px;
        cursor: pointer;
        font-size: 14px;
        text-align: left;
        color: #16181A;
        .iconfont{
          margin-right: 6px;
          margin-left: 12px;
        }
      }
    }
  }
  .rightList{
    background: #FFFFFF;
    height: 100%;
  }

  .activeItem{
    background: rgba(6,110,183,.1);
    color: #066EB7 !important;
  }
::v-deep .itemDivbadge{
  // width: 100%;
  // text-align: left;
  // padding-left: 12px;
  float: right;
  top: 4px;
  margin-right: 12px;
  top: 5px;
 .el-badge__content.is-fixed{
    top: 22px;
    // right: 50px;
  }
}
</style>